/**
 * Base class for integration events used in the Integration Bus.
 * Events are asynchronous, non-blocking notifications, typically implemented using a publish-subscribe mechanism
 */
abstract class IntegrationEvent<TPayload = void> {
    /**
     * Unique key identifying the event type.
     * Defined in IntegrationBusFactory.createEvent.
     */
    public static readonly eventKey: string;

    /** Type discriminator to differentiate between events and requests  */
    public readonly integrationBusObjectType = "event" as const;

    /** The payload of the event. */
    public readonly payload?: TPayload;

    /**
     * Constructor to initialize the event with an optional payload.
     * @param payload The payload of the event.
     */
    constructor(payload: TPayload) {
        this.payload = payload;
    }
}

export { IntegrationEvent };
